import { newSpecPage } from '@stencil/core/testing'
import { CobaltSelect } from '../cobalt-select'

describe('core-select', () => {
  it('should render select element', async () => {
    const page = await newSpecPage({
      components: [CobaltSelect],
      html: '<cobalt-select label="Label" options=\'[ { "value": "Value1" }, { "value": "Value2" }, { "value": "Value3" }, { "value": "Value4" }, { "value": "Value5" }, { "value": "Value6" }, { "value": "Value7" }, { "value": "Value8" }, { "value": "Value9" }, { "value": "Value10" }]\'></core-select>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-select label="Label" options='[ { "value": "Value1" }, { "value": "Value2" }, { "value": "Value3" }, { "value": "Value4" }, { "value": "Value5" }, { "value": "Value6" }, { "value": "Value7" }, { "value": "Value8" }, { "value": "Value9" }, { "value": "Value10" }]'>
        <core-select format="inside" label="Label" options='[ { "value": "Value1" }, { "value": "Value2" }, { "value": "Value3" }, { "value": "Value4" }, { "value": "Value5" }, { "value": "Value6" }, { "value": "Value7" }, { "value": "Value8" }, { "value": "Value9" }, { "value": "Value10" }]' placeholder="Select an option" requirement="mandatory"></core-select>
      </cobalt-select>
    `)
  })
  it('should render select element with section', async () => {
    const page = await newSpecPage({
      components: [CobaltSelect],
      html: '<cobalt-select label="Label" options=\'[ { "title": "Section1", "options": [ { "value": "Value1" }, { "value": "Value2" }, { "value": "Value3" }, { "value": "Value4" }, { "value": "Value5" }, { "value": "Value6" }, { "value": "Value7" }, { "value": "Value8" }, { "value": "Value9" }, { "value": "Value10" }] }]\'></core-select>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-select label="Label" options='[ { "title": "Section1", "options": [ { "value": "Value1" }, { "value": "Value2" }, { "value": "Value3" }, { "value": "Value4" }, { "value": "Value5" }, { "value": "Value6" }, { "value": "Value7" }, { "value": "Value8" }, { "value": "Value9" }, { "value": "Value10" }] }]'>
        <core-select format="inside" label="Label" options='[ { "title": "Section1", "options": [ { "value": "Value1" }, { "value": "Value2" }, { "value": "Value3" }, { "value": "Value4" }, { "value": "Value5" }, { "value": "Value6" }, { "value": "Value7" }, { "value": "Value8" }, { "value": "Value9" }, { "value": "Value10" }] }]' placeholder="Select an option" requirement="mandatory"></core-select>
      </cobalt-select>
    `)
  })
  it('should change format to outside', async () => {
    const page = await newSpecPage({
      components: [CobaltSelect],
      html: '<cobalt-select label="Label" format="outside"></core-select>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-select format="outside" label="Label">
        <core-select format="outside" label="Label" placeholder="Select an option" requirement="mandatory"></core-select>
      </cobalt-select>
    `)
  })
  it('should change format to aside', async () => {
    const page = await newSpecPage({
      components: [CobaltSelect],
      html: '<cobalt-select label="Label" format="aside"></core-select>'
    })
    expect(page.root).toEqualHtml(`
      <cobalt-select format="aside" label="Label">
        <core-select format="aside" label="Label" placeholder="Select an option" requirement="mandatory"></core-select>
      </cobalt-select>
    `)
  })
  it('should render select in error state', async () => {
    const page = await newSpecPage({
      components: [CobaltSelect],
      html: '<cobalt-select label="Label" error-message="This field is required"></core-select>'
    })
    expect(page.root).toEqualHtml(`
    <cobalt-select error-message="This field is required" label="Label">
      <core-select errormessage="This field is required" format="inside" label="Label" placeholder="Select an option" requirement="mandatory"></core-select>
    </cobalt-select>
    `)
  })
})
